import { Backend } from '@/_axios';

export default {
  list(params) {
    return Backend.get('/users/', { params });
  },
  createData() {
    return Backend.get('/users/create');
  },
  editData(userId) {
    return Backend.get(`/users/${userId}/edit`);
  },
  create(createData) {
    return Backend.post('/users/', createData);
  },
  update(updateData) {
    return Backend.put(`/users/${updateData.id}`, updateData);
  },
  updateActive(id, isActive) {
    return Backend.put(`/users/${id}/change-active`, { is_active: isActive });
  },
  updatePassword(userId, data) {
    return Backend.put(`/users/${userId}/change-password`, data);
  },
  startTrial(userId) {
    return Backend.put(`/users/${userId}/start-trial`);
  },
};
